import { captureException } from '@sentry/react';

import { useAuthStore } from '@/stores/auth';

export const clearStorage = (): void => localStorage.clear();

export const getItemFromStorage = (key: string): string | void => {
    if (!localStorage) {
        return;
    }

    try {
        return JSON.parse(localStorage.getItem(key) as any);
    } catch (error) {
        captureException(error);
    }
};

export const clearLocalStorageBesidesAuthToken = () => {
    const tokenValue = useAuthStore.getState().accessToken;

    // Clear the entire localStorage
    localStorage.clear();

    // Set back the "token" key with its value
    if (tokenValue) {
        localStorage.setItem('token', tokenValue);
    }
};

export const storeItem = (key: string, item: any) => {
    if (!localStorage) {
        return;
    }

    try {
        return localStorage.setItem(key, JSON.stringify(item));
    } catch (error) {
        captureException(error);
    }
};

export const removeItemFromStorage = (key: string) => {
    if (!localStorage) {
        return;
    }

    try {
        return localStorage.removeItem(key);
    } catch (error) {
        captureException(error);
    }
};

export const removeKeysFromLocalStorage = (data: string | string[]): any => {
    if (typeof data === 'string') {
        localStorage.removeItem(data);
    } else {
        data.forEach((key: string) => localStorage.removeItem(key));
    }
};
